import React from 'react'
import './SearchPage.css'
import SearchResult from './SearchResult'
function SearchPage() {
  return (
    <div className='searchPage'>
        <div className='searchPage__info'>
            <h1>Matches</h1>
            {/*<button>Cancellation Flexibility</button>
            <button>Type</button>
            <button>Price</button>
            <button>Rooms and beds</button>
            <button>More filters</button>*/}
  </div>
        <SearchResult 
        img='https://rentpath-res.cloudinary.com/$img_current/t_3x2_jpg_md/t_unpaid/fbd5b93dbe0f60358fb87492ffcb1c5d'
        location='3 blocks away from campus'
        title='Single bedroom apartment near campus grounds'
        description='2 guest, 1 bedroom, 1 bath, wifi, kitchen, free parking, washer/dryer'
        star={'⭐ 4.6'}
        price='$55 / night'
        total = '$165 total'
        />
        <SearchResult 
        img='https://rentpath-res.cloudinary.com/$img_current/t_3x2_jpg_md/t_unpaid/fbd5b93dbe0f60358fb87492ffcb1c5d'
        location='3 blocks away from campus'
        title='Single bedroom apartment near campus grounds'
        description='2 guest, 1 bedroom, 1 bath, wifi, kitchen, free parking, washer/dryer'
        star={'⭐ 4.6'}
        price='$55 / night'
        total = '$165 total'
        />
         <SearchResult 
        img='https://rentpath-res.cloudinary.com/$img_current/t_3x2_jpg_md/t_unpaid/fbd5b93dbe0f60358fb87492ffcb1c5d'
        location='3 blocks away from campus'
        title='Single bedroom apartment near campus grounds'
        description='2 guest, 1 bedroom, 1 bath, wifi, kitchen, free parking, washer/dryer'
        star={'⭐ 4.6'}
        price='$55 / night'
        total = '$165 total'
        />
         <SearchResult 
        img='https://rentpath-res.cloudinary.com/$img_current/t_3x2_jpg_md/t_unpaid/fbd5b93dbe0f60358fb87492ffcb1c5d'
        location='3 blocks away from campus'
        title='Single bedroom apartment near campus grounds'
        description='2 guest, 1 bedroom, 1 bath, wifi, kitchen, free parking, washer/dryer'
        star={'⭐ 4.6'}
        price='$55 / night'
        total = '$165 total'
        />
         <SearchResult 
        img='https://rentpath-res.cloudinary.com/$img_current/t_3x2_jpg_md/t_unpaid/fbd5b93dbe0f60358fb87492ffcb1c5d'
        location='3 blocks away from campus'
        title='Single bedroom apartment near campus grounds'
        description='2 guest, 1 bedroom, 1 bath, wifi, kitchen, free parking, washer/dryer'
        star={'⭐ 4.6'}
        price='$55 / night'
        total = '$165 total'
        />
         <SearchResult 
        img='https://rentpath-res.cloudinary.com/$img_current/t_3x2_jpg_md/t_unpaid/fbd5b93dbe0f60358fb87492ffcb1c5d'
        location='3 blocks away from campus'
        title='Single bedroom apartment near campus grounds'
        description='2 guest, 1 bedroom, 1 bath, wifi, kitchen, free parking, washer/dryer'
        star={'⭐ 4.6'}
        price='$55 / night'
        total = '$165 total'
        />
    </div>
    
  )
}

export default SearchPage